"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var throw_1 = require("rxjs/observable/throw");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
/**
 * Common handler for response errors logging a message to the console and returning with a rejection.
 * @param {HttpErrorResponse} error - The error response that occurred.
 * @returns {ErrorObservable} An observable that emits an error notification using the given error argument.
 */
function handleResponseError(error) {
    idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(error);
    var message = error.error instanceof ErrorEvent
        ? "An error occurred: " + error.error.message
        : error;
    return throw_1._throw(message);
}
exports.handleResponseError = handleResponseError;
//# sourceMappingURL=error-helper.js.map